import { FiltersStateType } from 'utils/types/FiltersStateType';
import { ModulesType } from 'utils/types/ModulesType';
import {
    DuplicateFlatAiDto,
    DuplicateHouseAiDto,
    DuplicateOtherAiDto,
    DuplicatePlotAiDto,
    NoteDto,
    SaleAiFlatDetailDto,
    SaleAiFlatDto,
    SaleAiFlatHashDto,
    SaleAiHouseDetailDto,
    SaleAiHouseDto,
    SaleAiHouseHashDto,
    SaleAiOtherDetailDto,
    SaleAiOtherDto,
    SaleAiOtherHashDto,
    SaleAiPlotDetailDto,
    SaleAiPlotDto,
    SaleAiPlotHashDto,
    SaleOpinionResult,
    SortType
} from 'utils/types/SaleModels';

export interface SaleStateType {
    isLoading: boolean,
    saleOfferList: SaleOffersResponse,
    sortType: SortType;
    filtersState: FiltersStateType;
    pageType: ModulesType;
    filteredCity: string;
    notes?: NoteDto[],
    scoreAndOpinions?: SaleOpinionResult,
}

export type SaleOfferDetailsResponse = SaleAiFlatDetailDto & SaleAiPlotDetailDto & SaleAiHouseDetailDto & SaleAiOtherDetailDto;

export type SaleOfferHashResponse = SaleAiFlatHashDto & SaleAiPlotHashDto & SaleAiHouseHashDto & SaleAiOtherHashDto;

type DuplicateDto = DuplicateFlatAiDto & DuplicatePlotAiDto & DuplicateHouseAiDto & DuplicateOtherAiDto;

type SaleOffersDto = SaleAiHouseDto & SaleAiFlatDto & SaleAiPlotDto & SaleAiOtherDto;

export type SaleOfferDuplicatesResponse = DuplicateDto

export interface SaleOfferResponseContent extends SaleOffersDto {
    detailedContent?: SaleOfferDetailsResponse;
    duplicates?: SaleOfferDuplicatesResponse[];
}

export interface SaleOffersResponse {
    empty: boolean,
    content: SaleOfferResponseContent[],
    pageable: {
        pageNumber: number,
        pageSize: number,
    },
    numberOfElements: number,
    totalPages: number,
    totalElements: number,
    last: boolean,
    size: number,
    afterSearch: boolean,
}

export const saleInitialState: SaleStateType = {
    isLoading: false,
    saleOfferList: {
        empty: false,
        content: [],
        pageable: {
            pageNumber: 1,
            pageSize: 0
        },
        numberOfElements: 0,
        size: 25,
        totalPages: 0,
        totalElements: 0,
        last: false,
        afterSearch: false
    },
    sortType: SortType.DATE_ASC,
    filtersState: {} as FiltersStateType,
    pageType: 'advertisement',
    filteredCity: ''
};
